<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Vigile su patrimonio" titleLevel="h1">
          <template slot="partOne"> Vigile su <br></template>
          <!-- <template slot="partTwo"></template> -->
          <template slot="partThree"> patrimonio </template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Vigile su patrimonio'" videoEmbed="ADMINISTRACIONDINERO48VIgileSuPatrimonio.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Por sí mismo, el <strong>patrimonio</strong> no dura para siempre. Todas sus decisiones financieras lo afectan. <br><br>
          Su patrimonio es con lo que cuenta para su <strong>bienestar futuro</strong>.
        </p>
      </v-flex>
      <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="420" imaSrc="contenido/diapositiva_49" imaAlt="Vigilando el patrimonio con lupa"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-48.vue?ef8958a0